/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';
import {ManutencaoProgramadaListComponent} from "./manutencao-programada-list/manutencao-programada-list.component";
import {ordensServicoRoute} from "../ordens-servico/shared/data.service";
import {newRoute} from "../../shared/services/data.service";
import {OrdemServicosFormComponent} from "../ordens-servico/ordem-servico-form/ordem-servico-form.component";
import {servicosRoute} from "../servicos/shared/data.service";
import {ServicoBemFormComponent} from "../servicos/servico-bens/servico-bem-form/servico-bem-form.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class manutencaoPprogramadaRoutingModule {}

export const manutencaoProgramadaRoutes: any[] = [
    {
        path: '',
        component: ManutencaoProgramadaListComponent
    },{
        path: ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: servicosRoute + '/:id',
        component: ServicoBemFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/manutencao-programada-routing.module.ts
 **/